/* eslint-disable complexity */
import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { EntityTypeMap, ValidationResult } from 'types';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';

export function validateConnectionSelectAcl (): boolean {
    return validateAcls([ 'connection_select' ]);
}

export function validateConnectionUpdateAcl (): boolean {
    return validateAcls([ 'connection_update' ]);
}

export function validateConnection (entityData: EntityTypeMap['connection'], originalEntityData: EntityTypeMap['connection'] | null): ValidationResult {
    if (!entityData.name) {
        return {
            status: 'error',
            errorMessage: 'Connection name is required',
        };
    }

    if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.MqttBroker) {
        if (!entityData.connectionConfig.config.details.username) {
            // is username always required? I dont _think_ so, but we should leave this hear until we have a reason to remove it
            return {
                status: 'error',
                errorMessage: 'Mqtt broker username is required',
            };
        }
        if (!entityData.connectionConfig.config.details.password) {
            // is password always required? I dont _think_ so, but we should leave this hear until we have a reason to remove it
            return {
                status: 'error',
                errorMessage: 'Mqtt broker password is required',
            };
        }
        if (!entityData.connectionConfig.config.details.url) {
            return {
                status: 'error',
                errorMessage: 'Mqtt broker url is required',
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.Ptl110PickLight) {
        if (entityData.connectionConfig.config.details.kind === 'eth') {
            if (!entityData.connectionConfig.config.details.ip) {
                return {
                    status: 'error',
                    errorMessage: 'DXMR90 IP is required',
                };
            }
            if (entityData.connectionConfig.config.details.port < 1) {
                return {
                    status: 'error',
                    errorMessage: 'DXMR90 connection must have a valid port',
                };
            }
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.Serial) {
        //
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.TcpClient) {
        if (!entityData.connectionConfig.config.details.ip) {
            return {
                status: 'error',
                errorMessage: 'Tcp client IP is required',
            };
        }
        if (entityData.connectionConfig.config.details.port < 1) {
            return {
                status: 'error',
                errorMessage: 'Tcp client connection must have a valid port',
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.TcpServer) {
        if (entityData.connectionConfig.config.details.port < 1) {
            return {
                status: 'error',
                errorMessage: 'Tcp server connection must have a valid port',
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.UdpSocket) {
        if (entityData.connectionConfig.config.details.port < 1) {
            return {
                status: 'error',
                errorMessage: 'Udp socket connection must have a valid port',
            };
        }
        if (entityData.connectionConfig.config.details.bind.useBind) {
            if (entityData.connectionConfig.config.details.bind.clientTimeoutMs < 1) {
                return {
                    status: 'error',
                    errorMessage: 'Udp socket client timeout must be at least 1ms',
                };
            }
        } else if (!entityData.connectionConfig.config.details.bind.ip) {
            return {
                status: 'error',
                errorMessage: 'Udp socket IP is required',
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.IoLinkMaster) {
        if (entityData.connectionConfig.config.details.kind === 'dxmr904k') {
            if (!entityData.connectionConfig.config.details.ip) {
                return {
                    status: 'error',
                    errorMessage: 'DXMR904K IP is required',
                };
            }
            if (entityData.connectionConfig.config.details.channels[0].config) {
                if (entityData.connectionConfig.config.details.channels[0].config.kind === 'ptl110PickLight') {
                    if (entityData.connectionConfig.config.details.channels[0].config.port < 1) {
                        return {
                            status: 'error',
                            errorMessage: 'PTL 110 Pick Light device must have a valid port',
                        };
                    }
                } else {
                    const u: never = entityData.connectionConfig.config.details.channels[0].config.kind;
                    return {
                        status: 'error',
                        errorMessage: `Unknown channel 0 device kind: "${u}"`,
                    };
                }
            }
        } else {
            const u: never = entityData.connectionConfig.config.details.kind;
            return {
                status: 'error',
                errorMessage: `Unknown io link master device: "${JSON.stringify(u)}"`,
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.OpenProtocol) {
        if (!entityData.connectionConfig.config.details.ip) {
            return {
                status: 'error',
                errorMessage: 'Open Protocol IP is required',
            };
        }
        if (entityData.connectionConfig.config.details.port < 1) {
            return {
                status: 'error',
                errorMessage: 'Open Protocol Port is required',
            };
        }
    } else if (entityData.connectionConfig.config.kind === ArgoConnectionKindEnum.TorqueTool) {
        if (!entityData.connectionConfig.config.details.ip) {
            return {
                status: 'error',
                errorMessage: 'Torque Tool IP is required',
            };
        }
        if (entityData.connectionConfig.config.details.port < 1) {
            return {
                status: 'error',
                errorMessage: 'Torque Tool Port is required',
            };
        }
    } else {
        const u: never = entityData.connectionConfig.config;
        return {
            status: 'error',
            errorMessage: `Unknown connection kind: ${JSON.stringify(u)}`,
        };
    }

    if (originalEntityData && originalEntityData.connectionConfig.config.kind !== entityData.connectionConfig.config.kind) {
        return {
            status: 'error',
            errorMessage: 'Connection kind cannot be changed after creation',
        };
    }

    return {
        status: 'success',
    };
}
